/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeflyerssizea63Inputs */

const en_placeflyerssizea63 = /** @type {(inputs: Placeflyerssizea63Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A6`)
};

const de_placeflyerssizea63 = /** @type {(inputs: Placeflyerssizea63Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A6`)
};

/**
* | output |
* | --- |
* | "A6" |
*
* @param {Placeflyerssizea63Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyerssizea63 = /** @type {((inputs?: Placeflyerssizea63Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyerssizea63Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyerssizea63(inputs)
	return de_placeflyerssizea63(inputs)
});
export { placeflyerssizea63 as "placeFlyersSizeA6" }